export default __webpack_public_path__ + "static/media/membership.eb567df8.png";